import { api } from '@/core/api/base.api.client'

export interface SessionUser {
  id: string
  username: string
  display_name: string | null
  email: string | null
  is_admin: boolean
  workspace_id: string | null
}

export interface LoginResult {
  access_token: string
  token_type: string
  expires_at: string
  user: SessionUser
}

export interface SessionMode {
  /** False only when the server has no accounts at all (fresh install). */
  login_required: boolean
  mode: 'password' | 'open'
}

export const sessionApi = {
  /** Unauthenticated: tells the sign-in page whether a sign-in is needed. */
  mode: () => api.get<SessionMode>('/auth/session'),

  login: (username: string, password: string, remember: boolean) =>
    api.post<LoginResult>('/auth/login', { username, password, remember }),

  logout: () => api.post<{ signed_out: boolean }>('/auth/logout'),

  me: () =>
    api.get<{
      user_id: string
      username: string | null
      display_name: string | null
      email: string | null
      is_admin: boolean
      dev_mode: boolean
      workspace_id: string | null
    }>('/auth/me'),
}
